import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()(() => {
    return {
        empty: {
            fill: 'lightgrey !important',
        },
        hoverOnly: {
            opacity: 0,
            visibility: 'hidden',
            transition: 'opacity 0.2s ease-in-out, visibility 0.2s ease-in-out',

            '.MuiDataGrid-columnHeader:hover &': {
                opacity: 1,
                visibility: 'visible',
            },
        },

        activeFilter: {
            opacity: 1,
            visibility: 'visible',
        },
    }
})

export default useStyles
